import axios from "axios";

export default {
  state: {
    list: [],
  },
  getters: {
    getList(state) {
      return state.list;
    },
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
  },
  actions: {
    fetchList(store) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/delegation",
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            store.commit("setList", res.data.data);
            resolve(res.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    createDelegation(store, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/delegation",
          data: payload,
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateDelegation({ dispatch }, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url: process.env.VUE_APP_BACKEND + "api/delegation",
          params: { id: payload },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            dispatch("fetchList");
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkDelegation(store, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/checkDelegation",
          params: {
            tlc: payload.tlc,
            aplikasi: payload.aplikasi
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token
          },
        })
          .then(res => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
